
export default {
    namespaced: true,
    state: {
        datosAccion:{},
        dialogListar: false
    },
    mutations: {
        SET_DIALOGLISTAR(state, mostrar){
            state.dialogListar = mostrar;
        },
        SET_DATOSACCION(state, datos){
            state.datosAccion = datos;
        }
    },
    actions: {
        setDialogListar({commit}, mostrar){
            commit('SET_DIALOGLISTAR', mostrar);
        },
        setDatosAccion({commit}, datos){
            commit('SET_DATOSACCION', datos);
        }
    }
}